export default {"src":"/_next/static/media/heart.c91bdd21.svg","height":200,"width":226,"blurWidth":0,"blurHeight":0};